import isUserLoggedIn from "./is-user-logged-in.bootstrap.js"
import { loginUI } from "../child-app-active.functions.js"

export default function() {
  return isUserLoggedIn().then(sessionIsValid => {
    if (!sessionIsValid && !loginUI(window.location)) {
      // The user is not logged in
      // Redirect to login page, but only if they aren't already on a login page
      const encodedUrl = window.encodeURIComponent(window.location.href)
      const baseRoute = window.appIsMobile ? "m" : "#"
      window.location.href = `${window.location.origin}/${baseRoute}/login?redirect_url=${encodedUrl}`
    }
  })
}
